<template>
  <div class="h-full absolute inset-0 z-10 bg-color-main">
    <div class="h-full flex flex-col">
      <div>
        <el-page-header @back="$emit('cancel')" content="任务详情"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="任务基本信息" name="baseInfo">
            <base-form :currentRow="currentRow" :disabled="true" />
          </el-collapse-item>
          <el-collapse-item title="任务周期配置" name="planUnit">
            <detail-table :currentRow="currentRow"></detail-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import BaseForm from '../TimingTask/BaseForm'
import DetailTable from './DetailTable'

export default {
  name: 'base-detail',
  props: {
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    BaseForm,
    DetailTable,
  },
  data() {
    return {
      loading: false,
      collapseActiveName: ['baseInfo', 'planUnit'],
    }
  },
  methods: {},
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
